<script setup>
defineProps({
  cards: {
    type: Array,
    required: true,
  },
});

function getCounterPosition(index) {
  return index + 1 > 9 ? { '--counter-position': '-160px' } : '';
}
</script>

<template>
  <ol class="article-cards">
    <li
      v-for="(card, index) in cards"
      :key="index"
      class="article-cards__item"
      :style="getCounterPosition(index)"
    >
      <span :id="card._key" class="article-cards__anchor"></span>
      <ArticleCardsItem :card-content="card.content" />
    </li>
  </ol>
</template>

<style lang="postcss">
.article-cards {
  --counter-position: -80px;

  width: 100%;
  margin-right: 16px;
  padding-left: 50px;

  @media (--tablet-vp) {
    --counter-position: -50px;
  }

  &__item {
    counter-increment: card-item 1;
    position: relative;
    z-index: 1;

    .recommended-post__card {
      min-width: 240px;
    }

    .content-collapsible,
    .content-carousel__text {
      padding: 0;
    }

    .content-carousel {
      max-width: 800px;
      margin: 0 auto;
      overflow: hidden;
    }

    &:not(:last-child) {
      margin-bottom: 40px;
    }

    &::after {
      content: counter(card-item);
      position: absolute;
      z-index: 2;
      top: 0;
      left: var(--counter-position);
      right: auto;
      bottom: auto;
      font-family: var(--title-font-family);
      font-size: 130px;
      line-height: 130px;
      font-weight: 700;
      color: rgba(248, 248, 248, 40%);

      @media (--tablet-vp) {
        font-size: 80px;
        line-height: 80px;
      }
    }
  }

  &__anchor {
    position: absolute;
    left: 0;
    top: calc(-1 * var(--main-header-height));
  }

  @media (--small-vp) {
    width: auto;
    margin-right: -8px;
    margin-left: -8px;
    padding-left: 0;

    &__item {
      &:not(:last-child) {
        margin-bottom: 64px;
      }

      &::after {
        top: -40px;
        left: 12px;
        font-size: 48px;
        line-height: 48px;
      }
    }
  }
}
</style>
